import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Container, Row, Col, Table, Card, CardBody } from "reactstrap";
import CardItem from "./CardItem";
import Paginator from "components/Common/Paginator/Paginator";
import ClientsService from "services/Admin/ClientsService";
import { adminPrefix } from "configs/routePrefix";

const ManageClients = (props) => {
	const [loading, setLoading] = useState(false);
	const clientsService = new ClientsService();
	const [active, setActive] = useState("all");
	const [searchWord, setSearchWord] = useState("");
	const [area, setArea] = useState([]);
	const [list, setList] = useState([]);
	const [filtersParams, setFilterParams] = useState(null);
	const [shouldGetData, setShouldGetData] = useState(false);
	const [exportUrl, setExportUrl] = useState("");
	const [pageOptions, setPageOptions] = useState({
		sizePerPage: 10,
		totalSize: 1,
	});

	const OnSearchChange = (e) => {
		const search = e.target.value;
		setSearchWord(search);
	};

	const exportFileHandler = () => {
		setLoading(true);
		const params = {
			export: 1,
		};
		if (active != "all") params["status"] = active === "active" ? 1 : 0;
		if (searchWord.trim().length) params["keyword"] = searchWord.trim();
	};

	useEffect(() => {
		// debounce solution to reduce request data from api
		const timeoutId = setTimeout(() => {
			const params = {};
			if (active != "all") params["status"] = active === "active" ? 1 : 0;
			if (searchWord.trim().length) params["keyword"] = searchWord;

			setFilterParams({ ...params });
		}, 1000);

		return () => clearTimeout(timeoutId);
	}, [active, searchWord]);

	useEffect(() => {
		const url = clientsService.getExportUrl(active, searchWord);
		setExportUrl(url);
	}, [active, searchWord]);

	const addHandler = () => {
		props.history.push(`${adminPrefix}/manage-clients/add-client`);
	};

	return (
		<React.Fragment>
			<div className="page-content">
				<MetaTags>
					<title>Manage Clients</title>
				</MetaTags>
				<Container fluid>
					<Row className="mb-1">
						<Col md={6}>
							<h4>Manage Clients</h4>
						</Col>
					</Row>
					<Row>
						<Col md={6}>
							<div className="input-group mb-3">
								<input
									type="text"
									className="form-control"
									value={searchWord}
									onChange={(e) => OnSearchChange(e)}
									placeholder="Search by client username, email, phone number, I.D"
								/>
							</div>
						</Col>
						{/* <Col md={6}>
              <div className="d-md-flex justify-content-md-end mb-2">
                <button
                  className="btn btnUpload btnHeight btnHeight px-lg-4 me-2"
                  onClick={() => window.open(exportUrl)}
                >
                  Export Excel Sheet
                </button>
               </div>
            </Col> */}
						<Col lg={3} md={3}></Col>
						<Col lg={3} md={3} className="text-end">
							<button
								className="btn btn-success btnHeight px-lg-4"
								onClick={addHandler}>
								Add New Client
							</button>
						</Col>
					</Row>
					<Row className="mb-4">
						<Col md={6} sm={8} className="mb-3">
							<button
								className="btn btnHeight me-2 px-4"
								style={{
									background: active == "all" ? "#556ee6" : "#f4f4f4",
									color: active == "all" ? "#FFF" : "#495057",
								}}
								onClick={() => {
									setActive("all");
								}}>
								All
							</button>
							<button
								className="btn btnHeight me-2 px-4"
								style={{
									background: active == "active" ? "#556ee6" : "#f4f4f4",
									color: active == "active" ? "#FFF" : "#495057",
								}}
								onClick={() => {
									setActive("active");
								}}>
								Active
							</button>
							<button
								className="btn btnHeight me-2 px-4"
								style={{
									background: active == "deactive" ? "#556ee6" : "#f4f4f4",
									color: active == "deactive" ? "#FFF" : "#495057",
								}}
								onClick={() => {
									setActive("deactive");
								}}>
								Deactive
							</button>
						</Col>
					</Row>
					<div>
						<Card className="w-100 mt-4">
							<CardBody>
								<div className="py-3">
									<div>
										<div className="table-responsive">
											<Table>
												<thead>
													<tr className="bgHeaderTable">
														<th className="font-size-14">I.D</th>
														<th className="font-size-14">Name</th>
														<th className="font-size-14">User Name</th>
														<th className="font-size-14">Email</th>
														<th className="font-size-14">Phone Number</th>
														<th className="font-size-14">Status</th>
														<th className="font-size-14"></th>
													</tr>
												</thead>
												<tbody>
													{list.map((item, index) => (
														<CardItem
															key={index}
															index={index}
															{...item}
															item={item}
															setShouldGetData={setShouldGetData}
														/>
													))}
												</tbody>
											</Table>
										</div>
									</div>
								</div>
							</CardBody>
						</Card>
						<Row className="d-flex justify-content-end">
							<Col className="d-flex justify-content-between" md={12} sm={12}>
								<Paginator
									service={clientsService}
									pageOptions={pageOptions}
									setData={(data) => setList([...data])}
									setPageOptions={setPageOptions}
									filtersParams={filtersParams}
									shouldGetData={shouldGetData}
									setShouldGetData={() => {}}
								/>
							</Col>
						</Row>
					</div>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default ManageClients;
